import { useEffect, useState } from "react";
import { connect } from "react-redux";
import ActionDetailsComponent from "components/ActionTracking/ActionDetail";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { useParams } from "react-router";
import { successToast } from "helpers/Notification";
import { ToastContainer } from "react-toastify";
import { errorToast } from "helpers/Notification";

const ActionDetails = (props) => {
    const {
        FetchDetails,
        SetSelectedMenu,
        errorMessage,
        PutAction,
        GetAllResources,
        resources,GetEmployees,loggedUser,systemSettings
    } = props;
    const { id } = useParams()
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState({})


    const getDetails = async () => {
        const resp = await FetchDetails(`api/meeting-action/${id}`)
        if (resp.status) {
            setInfo(resp.data.data)
        }
    }
    useEffect(() => {
        if (id) {
            getDetails().then()
        }
    }, [id]);

    useEffect(() => {
        SetSelectedMenu({
            menu: "action",
            title: "Action Tracking"
        })
    }, []);
    useEffect(() => {
        if (errorMessage) setLoading(false);
      }, [errorMessage]);
    
      useEffect(() => {
        GetAllResources();
      }, [])

    const onSubmit = async (data) => {
        const { status } = data
        const response = await PutAction(`api/meeting-action/${info?.id}`,data);
        if (response?.status) {
            successToast(response?.data?.message);
            getDetails()
        }else{
            errorToast(response?.response?.data?.message)
        }

    };
    return (
        <div className="w-full mb-12 px-4">
            <ToastContainer />
            <ActionDetailsComponent
                info={info}
                setInfo={setInfo}
                GetDetails={getDetails}
                setLoading={setLoading}
                loading={loading}
                loggedUser={loggedUser}
                onSubmit={onSubmit}
                resources={resources?.data}
                GetEmployees={GetEmployees}
                systemSettings={systemSettings}

            />
        </div>
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(ActionDetails);
